import { base } from "./../path";
const baseGestion = base.concat("/licenses");
const paths = {
  licenses: baseGestion,
  license: baseGestion.concat("/:id"),
  licenseManagement: baseGestion.concat("/:id/ticket-management/:management"),
  licenseHistory: baseGestion.concat("/ticket-management/:id/history"),
};

export { paths };
